import { render } from "./OuterContentsInputPage.vue?vue&type=template&id=5f390947&scoped=true&ts=true"
import script from "./OuterContentsInputPage.vue?vue&type=script&lang=ts"
export * from "./OuterContentsInputPage.vue?vue&type=script&lang=ts"

import "./OuterContentsInputPage.vue?vue&type=style&index=0&id=5f390947&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f390947"]])

export default __exports__